<template>
  <slot></slot>

  <modal :id="modalId">

    <template v-slot:header>
      <h4 class="modal-title">Delete Adjusters</h4>
    </template>

    <div v-if="checkedIds().length > 0" class="text-danger text-center">
      <strong>Are you sure you want to delete <strong>{{ checkedIds().length }}</strong> selected adjuster(s) from the smartlist?</strong>

      <div class="mt-3">
        All data in custom fields, if any, will be lost. This action cannot be undone.
      </div>
    </div>

    <div v-else class="alert alert-warning text-center mb-0">
      No adjusters selected.
    </div>

    <template v-slot:footer>
      <button type="button" class="btn btn-white" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Close</button>

      <form method="POST" :action="action">
        <input type="hidden" name="_token" :value="$csrf_token">
        <input type="hidden" name="_method" value="DELETE">
        <input type="hidden" name="adjuster_ids" :value="checkedIds()">
        <button v-if="checkedIds().length > 0" type="submit" class="btn btn-danger"><i class="fa fa-fw fa-user-times"></i> Confirm</button>
      </form>
    </template>

  </modal>
</template>

<script>
import HasModal from "../mixins/HasModal";
import { mapState } from 'pinia'
import { useCheckboxListStore } from "../../stores/checkboxList"

export default {
  mixins: [HasModal],

  props: {

    // Modal dialog id.
    modalId: {
      type: String,
      default: 'smartlistDeleteAdjusterModal'
    },

    // Form action value.
    action: {
      type: String,
      required: true
    },

  },

  /**
   * Computed values
   */
  computed: {
    ...mapState(useCheckboxListStore, ['checkedIds']),
  },
}
</script>
